/* screens/LanguageScreen.jsx */
import "./Profile.css";
import BackBtn from "./Shared/BackBtn";
import CheckIcon from "@mui/icons-material/Check";
import { CircularProgress } from "@mui/material";
import Flag from "react-country-flag";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../../../../../redux-store/auth/actions";
import { useState } from "react";
import backend from "../../../../../../../api";
import { useSnackbar } from "notistack";
import { motion, easeOut } from "framer-motion";

const langs = [
  {code:"us", name:"English"},
  {code:"sa", name:"Saudi Arabian"},
  {code:"es", name:"Spanish"},
  {code:"fr", name:"French"},
  {code:"de", name:"German"},
  {code:"ru", name:"Russian"},
];

export default function LanguageScreen(){
  const { user } = useSelector(s=>s.auth);
  const dispatch   = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [sel,setSel] = useState(user?.language||"English");
  const [saving,setSaving] = useState(false);

  const save=async()=>{
    setSaving(true);
    try{
      const {data}=await backend.put(`/api/user/${user._id}`,{language:sel});
      dispatch(setUserData({...user,...data.data}));
      enqueueSnackbar("Updated!",{variant:"success"});
    }catch(e){enqueueSnackbar("Error",{variant:"error"});}
    finally{setSaving(false);}
  };

  return (
    <motion.div className="pf-wrap" initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.3,
                            ease: easeOut,
                        }}>
      <BackBtn/>
      <h2 className="pf-modal-title" style={{textAlign:"left"}}>Change language</h2>

      {/* current language */}
      <div style={{margin:"24px 0 12px",fontWeight:600,color:"#37474F"}}>I speak</div>
      {langs.filter(l=>l.name===sel).map(l=>(
        <div key={l.name} className="pf-lang-row pf-on">
          <Flag countryCode={l.code.toUpperCase()} svg />
          {l.name} <CheckIcon sx={{marginLeft:"auto",color:"#F5A623"}}/>
        </div>
      ))}

      <div style={{margin:"28px 0 10px",fontWeight:600,color:"#37474F"}}>Change my language to</div>
      {langs.filter(l=>l.name!==sel).map(l=>(
        <div key={l.name} className="pf-lang-row" onClick={()=>setSel(l.name)}>
          <Flag countryCode={l.code.toUpperCase()} svg />
          {l.name}
        </div>
      ))}

      <button className="pf-save" onClick={save} disabled={saving}>
        {saving?<CircularProgress size={20} sx={{color:"#fff"}}/>:"Save"}
      </button>
    </motion.div>
  );
}
